import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionEyebrow } from './ui/SectionEyebrow';
const complianceItems = ['CJIS-aligned architecture', 'SOC 2 ready infrastructure', 'AES-256 encryption (rest & transit)', 'Role-based access control (RBAC)', 'US-hosted infrastructure', 'Immutable audit logging', 'SSO / SAML integration', 'Configurable data retention'];
export function TrustCompliance() {
  return <section id="compliance" className="py-24 bg-iris-black relative overflow-hidden" data-id="element-297">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-iris-green/50 to-transparent" data-id="element-298"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-64 bg-iris-green/5 blur-[100px] pointer-events-none" data-id="element-299"></div>

      <Container className="relative z-10 text-center" data-id="element-300">
        <SectionEyebrow text="Security & Compliance" className="justify-center mb-6" data-id="element-301" />
        <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-12 max-w-3xl mx-auto" data-id="element-302">
          BUILT TO THE STANDARDS YOUR AGENCY DEMANDS.
        </h2>

        <div className="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto mb-12" data-id="element-303">
          {complianceItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex items-center gap-2 bg-iris-surface border border-iris-border px-4 py-2 rounded-full" data-id="element-304">
              <CheckIcon className="w-4 h-4 text-iris-green" data-id="element-305" />
              <span className="text-sm font-mono text-iris-text" data-id="element-306">{item}</span>
            </motion.div>)}
        </div>

        <p className="text-iris-muted text-sm font-mono uppercase tracking-widest" data-id="element-307">
          // Security architecture documentation available under NDA.
        </p>
      </Container>
    </section>;
}